import React from 'react'
import Breadcrumb from '../breadCrumb/BreadCrumb'
import ServicesOne from '../container/pagesContainer/ServicesOne'
import Footer from '../footer/Footer'
import SEO from '../seo/SEO'
import TopNav from '../topNav/TopNav'

function Services() {
  return (
    <>
      <SEO title="Royality Technologies || Services" />
      <TopNav />
      <Breadcrumb title="Home" content="Our Services" image="/images/home/slide2.jpg" />
      <ServicesOne />
      <Footer />
    </>
  )
}

export default Services